// extracted by mini-css-extract-plugin
export default {"col2forimg":"Updateliveconnect_col2forimg__nAuOC"};